import request from '@/utils/request'
let platform = localStorage.getItem('platform')

export function build(data) {
    return request.post(`/${platform}/system/build`, data)
}

export function getOutput(data) {
    return request.get(`/${platform}/system/output`, data)
}
